import { Typography } from "@material-ui/core"

const Base = (props) => {

  return ( <>
    <Typography>
      We process all payments through Stripe, so you can pay with major credit and debit cards, Amazon Pay, Apple Pay, Google Pay, and even Cash App Pay. Basically, if it’s a legit way to buy things online, you’re probably good to go!
    </Typography>
  </> )
}

export default Base
